module.exports = __webpack_public_path__ + "img/barXChart.14c02211.png";